import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import firebase from 'firebase/app';
import 'firebase/auth';
import authUI from './services/authUIService';
import 'firebaseui/dist/firebaseui.css';

class SignIn extends Component {
  static propTypes() {
    return {
      error: PropTypes.string,
      dispatch: PropTypes.func.isRequired,
    };
  }

  componentDidMount = () => {
    const uiConfig = {
      signInSuccessUrl: '/home',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
    };

    authUI.getUI().then((ui) => ui.start('.firebaseui-auth-container', uiConfig));
  }

  componentWillUnmount = () => {
    authUI.getUI().then((ui) => ui.reset());
  }

  render() {
    return (<div className='firebaseui-auth-container'></div>);
  }
}

const mapStateToProps = state => {
  return {
    error: state.getIn(['auth', 'errorMessage'], ''),
  };
};

export default connect(mapStateToProps)(SignIn);



// WEBPACK FOOTER //
// ./src/SignIn.js